import { render, staticRenderFns } from "./ThirdStep.vue?vue&type=template&id=71bad636&"
import script from "./ThirdStep.vue?vue&type=script&lang=js&"
export * from "./ThirdStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports